import { useHistory } from "react-router-dom";
import firebase from "firebase/app";
import { useContext } from "react";
import { useNotifications } from "../../Notifications";
import ROUTES from "../../utils/routes";
import { userStore } from "../../utils/UserContext";
import { isProduction } from "../../utils/firebase";
import useSegment from "../../utils/useSegment";

export const useConnectPayPal = () => {
  const history = useHistory();
  const apiPrefix = `api-m.${!isProduction ? "sandbox." : ""}`;
  const { track, identify } = useSegment();
  const { user } = useContext(userStore);
  const { addNotification } = useNotifications();
  const updateLoggedInUser = firebase
    .functions()
    .httpsCallable("updateLoggedInUser");

  const connectPayPal = async (code: string) => {
    if (!user) {
      return;
    }

    // Fetch the users access token
    const accessQuery = await fetch(
      `https://${apiPrefix}paypal.com/v1/oauth2/token`,
      {
        method: "POST",
        headers: {
          Authorization: `Basic ${btoa(
            `${process.env.REACT_APP_PAYPAL_CLIENT_ID}:${process.env.REACT_APP_PAYPAL_SECRET}`
          )}}`,
          "Content-Type": "x-www-form-urlencoded",
          Accept: "application/json",
        },
        body: new URLSearchParams({
          grant_type: "authorization_code",
          code: `${code}`,
        }),
      }
    );

    // Show notification if failed to query for access token
    if (!accessQuery.ok) {
      return addNotification({
        message: "There's been an error connecting your account (ACCESS)",
        type: "error",
      });
    }

    const accessQueryRes = await accessQuery.json();

    // Fetch for user's PayPal token
    const tokenQuery = await fetch(
      `https://${apiPrefix}paypal.com/v1/identity/oauth2/userinfo?schema=paypalv1.1`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessQueryRes.access_token}`,
        },
      }
    );

    // Show notification if failed to query for PayPal token
    if (!tokenQuery.ok) {
      return addNotification({
        message: "There's been an error connecting your account (TOKEN)",
        type: "error",
      });
    }

    const { payer_id } = await tokenQuery.json();

    // Set the current user's PayPal token and the date they became an affiliate
    await updateLoggedInUser({
      payPalToken: payer_id,
      becameAffiliate: firebase.firestore.Timestamp.now(),
    });

    // Track when the user became an affiliate
    identify({ id: user.id, data: { is_affiliate: true } });
    track("Became Affiliate");

    // Reload the affiliates dashboard
    history.push(ROUTES.affiliates.dashboard);
    window.location.reload();
  };

  return { actions: { connectPayPal } };
};
